<template>
  <IconBase
    :width="iconSize"
    :height="iconSize"
    view-box="0 0 24 24"
    :icon-color="iconColor"
  >
    <IconCartPath />
  </IconBase>
</template>

<script lang="ts">
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconCartPath from "@/common/components/icons/IconCartPath.vue";
import { Options, Vue } from 'vue-class-component';
@Options({
  props: {
	iconSize: { type: [Number, String], required: true, default: 48 },
	iconColor: { type: String, default: "#333333" }
  },
  components: {
    IconBase,
    IconCartPath
  }
})
export default class IconCart extends Vue {
  iconSize!: string;
  iconColor!: string;
}
</script>
